module.exports = __webpack_public_path__ + "static/media/magnifying-glass.bd7b851a.png";